export const getReadDuration = (
  document: HTMLDocument,
  content: string
): string => {
  if (!document) return '';

  const div = document.createElement('div');
  div.innerHTML = content;

  const text = div.textContent || div.innerText;
  const words = text.split(' ');
  const perMinWordCount = 200;

  const duration = Math.ceil(words.length / perMinWordCount);

  return `${duration} min${duration > 1 ? 's' : ''}`;
};
